<template>
    <div class="txt-loading">
        <template v-if="time">{{time|time2text}}公布</template>
        <template v-else-if="message">{{message}}</template>
        <template v-else>成绩未公布，请耐心等待。</template>
    </div>
</template>

<script>
    export default {
        name: 'txt-wait-res',
        props: ['time', 'message']
    }
</script>
